(() => {
  const moveButtons = () => {
    const cartClear = document.querySelector('.cartclear_container > div');
    const printButton = document.querySelector('.cart-topbuttons button:first-child');
    cartClear.insertAdjacentElement('beforeend', printButton);
  };

  const carousels = () => {
    document.addEventListener('live-inventory-done', () => {
      setTimeout(() => {
        const recent = document?.querySelector('.basket-recently-viewed');
        const other = document?.querySelector('.basket-item-merch');

        if (!recent.querySelector('.lastviewedproducts-content')) {
          other.style.display = 'block';
        }
      }, 1000);
    }, false);
  };

  const basketChanges = () => {
    moveButtons();
    carousels();
  };

  $(document).ready(() => {
    const basketPage = document.querySelector('.ex-cart');
    if (!basketPage) return;

    basketChanges();
  });
})();
